import { Clerk } from '@clerk/clerk-js';

export let clerkInstance = new Clerk(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);

// Dev-only: when PrivateRoute's `?nockerk=1` bypass is active, Clerk's CDN
// script may be blocked / unreachable (headless preview, sandboxed runner).
// `clerkInstance.load()` then hangs forever, which blocks every API call.
// Skip the load and hand back a synthetic preview session so the rest of the
// dashboard can render against mocked /api responses. Production builds
// keep the original Clerk-backed behaviour.
const devClerkBypassActive = () => {
	if (!import.meta.env.DEV || typeof window === 'undefined') return false;
	try {
		return window.sessionStorage.getItem('unify.dev-bypass-clerk') === '1';
	} catch {
		return false;
	}
};

export const getAuthSession = async () => {
	if (devClerkBypassActive()) {
		return { email: 'preview@near.st', token: null, userId: 'preview-user' };
	}

	await clerkInstance.load?.();

	const email = clerkInstance.user?.primaryEmailAddress?.emailAddress;
	const token = await clerkInstance.session?.getToken();

	return { email, token, userId: clerkInstance.user?.id };
};

export const setClerkInstance = async (clerk) => {
	clerkInstance = clerk;
};

export const switchToOrganization = async (organizationId) => {
	await clerkInstance.load?.();
	await clerkInstance.user.reload();

	await clerkInstance.setActive({
		organization: organizationId
	});

	// Force Clerk instance to reload from servers
	await clerkInstance.load?.();
	await clerkInstance.user.reload();
};

export const getOrganizationMemberships = async (organizationId) => {
	const organization = await clerkInstance.getOrganization(organizationId);
	const response = await organization.getMemberships();
	return response.data || response;
};
